import Vue from 'vue'
import VueRouter from 'vue-router'
import BaseLayout from '@/views/BaseLayout';
import NewLayout from '@/views/NewLayout';
import ReservationView from '@/views/ReservationNewView';
import UserLogin from '@/views/mobile/UserLogin';
import AccountDoc from '@/views/mobile/AccountDoc';
import PrivacyDoc from '@/views/mobile/PrivacyDoc';
import HomeView from '@/views/HomeView';


// hack router push callback
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/yimt',
    name: 'yimt',
    component: () => import('@/views/YimtView')
  },
  {
    path: '/elem',
    name: 'elem',
    component: () => import('@/views/ElemView')
  },
  // {
  //   path: '/index',
  //   name: 'index',
  //   component: BaseLayout,
  //   redirect: '/index',
  //   children: [
  //     {
  //       path: '/index',
  //       name: 'index',
  //       component: () => import('@/views/IndexView')
  //     },
  //     {
  //       path: '/news',
  //       name: 'news',
  //       component: () => import('@/views/NewsView')
  //     },
  //     {
  //       path: '/game',
  //       name: 'game',
  //       component: () => import('@/views/GameView')
  //     },
  //   ]
  // },
  {
    path: '/information',
    name: 'information',
    component: NewLayout,
    redirect: '/information',
    children: [
      {
        path: '/information',
        name: 'information',
        component: () => import('@/views/InformationListView')
      },
      {
        path: '/informationDetail',
        name: 'informationDetail',
        component: () => import('@/views/InformationDetailView')
      }
    ]
  },
  {
    path: '/account/doc',
    name: 'accountDoc',
    component: AccountDoc
  },
  {
    path: '/privacy/doc',
    name: 'privacyDoc',
    component: PrivacyDoc
  },
  {
    path: '/fans',
    name: 'fans',
    component: () => import('@/views/FansView')
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('@/views/DownloadView')
  },
  {
    path: '/reservation',
    name: 'reservation',
    component: ReservationView
  },
  {
    path: '/reservation/ok',
    name: 'reservationOk',
    component: ReservationView
  },
  // {
  //   path: '/reservation/success',
  //   name: 'reservationSuccess',
  //   component: ReservationView
  // },
  // {
  //   path: '/reservation/awards',
  //   name: 'reservationAwards',
  //   component: ReservationView
  // },
  // {
  //   path: '/test',
  //   name: 'test',
  //   component: () => import('@/views/TestView')
  // },
  {
    path: '/mobileLogin',
    name: 'mobileLogin',
    component: UserLogin
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router;
